var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListing = function SvgListing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#102262",
    d: "M3.25 10a.75.75 0 0 0 1.5 0h-1.5Zm1.5 5a.75.75 0 0 0-1.5 0h1.5ZM8 2.75h8v-1.5H8v1.5ZM19.25 6v12h1.5V6h-1.5ZM16 21.25H8v1.5h8v-1.5ZM4.75 10V6h-1.5v4h1.5Zm0 8v-3h-1.5v3h1.5ZM8 21.25A3.25 3.25 0 0 1 4.75 18h-1.5A4.75 4.75 0 0 0 8 22.75v-1.5ZM19.25 18A3.25 3.25 0 0 1 16 21.25v1.5A4.75 4.75 0 0 0 20.75 18h-1.5ZM16 2.75A3.25 3.25 0 0 1 19.25 6h1.5A4.75 4.75 0 0 0 16 1.25v1.5Zm-8-1.5A4.75 4.75 0 0 0 3.25 6h1.5A3.25 3.25 0 0 1 8 2.75v-1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M8 7h4M8 12h4M16 7h-1M16 12h-1M8 17h4"
  })));
};
export default SvgListing;